"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StringValuePill = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _emotion = require("emotion");

var _Tag = _interopRequireDefault(require("@cimpress/react-components/lib/Tag"));

var _propTypes2 = require("../../shared/propTypes");

var _commonStyles = require("../../shared/commonStyles");

var _InlineEdit = _interopRequireDefault(require("@cimpress/react-components/lib/InlineEdit"));

var _messages = _interopRequireDefault(require("./messages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  .inline-edit-group {\n    margin-bottom: 15px !important;\n\n    .error-message {\n      top: 110%;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-size: 14px;\n\n  .inline-edit-group {\n    min-width: 50px;\n    margin-bottom: 5px !important;\n\n    input {\n      padding: inherit;\n    }\n\n    .resting-text {\n      margin-top: 5px;\n    }\n\n    .error-message {\n      top: 100%;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var inlineEditStyle = (0, _emotion.css)(_templateObject());
var inlineEditStyleWhenEditing = (0, _emotion.css)(_templateObject2());

var StringValuePill = function StringValuePill(_ref) {
  var value = _ref.value,
      values = _ref.values,
      canEdit = _ref.canEdit,
      onValueRemoved = _ref.onValueRemoved,
      onValueChanged = _ref.onValueChanged;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      existingValues = _useState2[0],
      updateExistingValues = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isEditing = _useState4[0],
      updateEditState = _useState4[1];

  (0, _react.useEffect)(function () {
    if (values) {
      var validationValues = values.filter(function (otherValue) {
        return otherValue.value.toLowerCase() !== value.value.toLowerCase();
      }).map(function (otherValue) {
        return otherValue.value.toLowerCase();
      });
      updateExistingValues(validationValues);
    }
  }, [value, values]);

  var onRemoveClicked = function onRemoveClicked() {
    return onValueRemoved(value);
  };

  var validateText = function validateText(inputText) {
    if (existingValues.includes(inputText.toLowerCase())) {
      return formatMessage(_messages["default"].invalidInput);
    }

    return null;
  };

  var updateValue = function updateValue(_ref2) {
    var inputValue = _ref2.value;

    var updatedValue = _objectSpread(_objectSpread({}, value), {}, {
      value: inputValue
    });

    onValueChanged(value, updatedValue);
  };

  var text = value ? value.value : '';
  var label = canEdit ?
  /*#__PURE__*/
  _react["default"].createElement("div", {
    className: isEditing ? (0, _emotion.cx)(inlineEditStyle, inlineEditStyleWhenEditing) : (0, _emotion.cx)(inlineEditStyle)
  },
  /*#__PURE__*/
  _react["default"].createElement(_InlineEdit["default"], {
    value: text,
    validateInput: validateText,
    onSave: updateValue,
    minWidth: 50,
    required: true,
    onEditStateChange: updateEditState,
    "data-testid": "InlineEdit"
  })) : text;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_Tag["default"], {
      className: (0, _emotion.cx)('tag', _commonStyles.fivePxMarginRight, _commonStyles.fivePxMarginBottom),
      label: label,
      removable: !isEditing,
      onRemoveClick: onRemoveClicked,
      "data-testid": "Tag"
    })
  );
};

exports.StringValuePill = StringValuePill;
StringValuePill.propTypes = {
  value: _propTypes["default"].shape(_propTypes2.valueShape).isRequired,
  values: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.valueShape)).isRequired,
  canEdit: _propTypes["default"].bool,
  onValueRemoved: _propTypes["default"].func.isRequired,
  onValueChanged: _propTypes["default"].func
};
StringValuePill.defaultProps = {
  value: {},
  canEdit: false
};